import { Component, OnInit } from '@angular/core';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState} from '../../../store/app.states';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {AuthService} from '../../../services/auth.service';
import {PatientService} from "../../../services/patient.service";

@Component({
  selector: 'app-contact-center',
  templateUrl: './contact-center.component.html',
  styleUrls: ['./contact-center.component.css']
})
// Pagina che contiene i pulsanti che portano alle funzioni per interagire con il dottore.
export class ContactCenterComponent implements OnInit {
  getAuthState: Observable<any>;
  customState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  message;
  title = 'Benvenuto';
  back = true;
  destination = '/landing';

  constructor(private store: Store<AppState>,
              private patientService: PatientService,
              private dialog: MatDialog,
              private router: Router,
              private authService: AuthService) {
    this.getAuthState = this.store.select(selectAuthState);
  }

  ngOnInit(): void {
    this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
    });
  }

  helloDoctor() {
    console.log('ok');
    this.patientService.helloDoctor().subscribe(bool => console.log(bool));
  }
}
